import { render, staticRenderFns } from "./GenericFeatureControl.vue?vue&type=template&id=28b517b6&scoped=true&"
import script from "./GenericFeatureControl.vue?vue&type=script&lang=js&"
export * from "./GenericFeatureControl.vue?vue&type=script&lang=js&"
import style0 from "./GenericFeatureControl.vue?vue&type=style&index=0&id=28b517b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b517b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28b517b6')) {
      api.createRecord('28b517b6', component.options)
    } else {
      api.reload('28b517b6', component.options)
    }
    module.hot.accept("./GenericFeatureControl.vue?vue&type=template&id=28b517b6&scoped=true&", function () {
      api.rerender('28b517b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/device/device_controls/GenericFeatureControl.vue"
export default component.exports